import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import axios from '../../utils/axios';

export const getChargers = createAsyncThunk('get/charger', async (params) => {
  const response = await axios.get('/charger/', { params });
  return response.data;
});

export const getFilteredChargers = createAsyncThunk('get/filteredCharger', async (params) => {
  const response = await axios.get('/charger/list_filtered/', { params });
  return response.data;
});

export const listChargersPicturesApproved = createAsyncThunk('list/chargerPicturesApproved', async (id) => {
  const response = await axios.get(`/charger-pictures/${id}/list_approved/`);
  return response.data;
});

export const addCharger = createAsyncThunk('add/charger', async (charger, { rejectWithValue }) => {
  try {
    const response = await axios.post('/charger/', charger);
    return response.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const addProviderToChargers = createAsyncThunk(
  'addProviderToChargers/charger',
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post('/charger/add_provider/', data);
      return response.data;
    } catch {
      return rejectWithValue(error);
    }
  }
);

export const updateCharger = createAsyncThunk('update/charger', async ({ chargerId, charger }, { rejectWithValue }) => {
  try {
    const response = await axios.put(`/charger/${chargerId}/`, charger);
    return response.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const deleteCharger = createAsyncThunk('deleteCharger', async (chargerId, { dispatch, rejectWithValue }) => {
  try {
    const response = await axios.delete(`/charger/${chargerId}/`);
    return response.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const deleteManyChargers = createAsyncThunk(
  'deleteManyChargers',
  async (chargerIDs, { dispatch, rejectWithValue }) => {
    try {
      const response = await axios.delete('/charger/delete_many/', { data: { arrId: chargerIDs } });
      dispatch(getChargers());
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getLogs = createAsyncThunk('log/charger', async (searchField) => {
  const response = await axios.get('/charger_logs/', {
    params: {
      query: searchField,
    },
  });
  return response.data;
});

export const getActiveSession = createAsyncThunk(
  'charger/activeChargerSession',
  async (charger_id, { rejectWithValue }) => {
    try {
      const response = await axios.get(`/active_charging_session/${charger_id}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getUserActiveSession = createAsyncThunk('chargingSession/getUserActiveSession', async () => {
  const response = await axios.get('/charging-session/get_user_active_session/');
  return response.data;
});

export const createChargingSession = createAsyncThunk(
  'charger/createChargingSession',
  async ({ user_id, vehicle_id, charger_id }, { rejectWithValue }) => {
    try {
      const response = await axios.get(`/create_charging_session/${user_id}/${vehicle_id}/${charger_id}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const terminateChargingSession = createAsyncThunk(
  'charger/terminateChargingSession',
  async ({ user_id, vehicle_id, charger_id }, { rejectWithValue }) => {
    try {
      const response = await axios.get(`/terminate_charging_session_admin/${user_id}/${charger_id}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const forceTerminateChargingSession = createAsyncThunk(
  'charger/forceTerminateChargingSession',
  async ({ charger_id }, { rejectWithValue }) => {
    try {
      const response = await axios.get(`force_terminate_charging_session/${charger_id}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getChargerLogs = createAsyncThunk('charger/chargerLog', async (serial_number, { rejectWithValue }) => {
  try {
    const response = await axios.get('/charger_log/', {
      params: {
        serial_number: serial_number,
      },
    });
    return response.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

/*----------------------------charger groups----------------------------*/

export const getChargerGroups = createAsyncThunk('get/charger-groups', async (params) => {
  const response = await axios.get('/charger-groups/', { params });
  return response.data;
});

export const getChargerGroup = createAsyncThunk('get/charger-group', async (id, { rejectWithValue }) => {
  try {
    const response = await axios.get(`/charger-groups/${id}/`);
    return response.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const addChargerGroups = createAsyncThunk('add/charger-groups', async (data, { dispatch, rejectWithValue }) => {
  try {
    const response = await axios.post('/charger-groups/', data);
    dispatch(getChargerGroups());
    return response.data;
  } catch (e) {
    return rejectWithValue(e);
  }
});

export const updateChargerGroups = createAsyncThunk(
  'update/charger-groups',
  async ({ data, id }, { dispatch, rejectWithValue }) => {
    try {
      const response = await axios.put(`/charger-groups/${id}/`, data);
      dispatch(getChargerGroups());
      return response.data;
    } catch (e) {
      return rejectWithValue(e);
    }
  }
);

export const addChargerToGroups = createAsyncThunk('addChargerToGroups', async (data, { rejectWithValue }) => {
  try {
    const response = await axios.post(`/charger-groups/add_charger_to_groups/`, data);
    return response.data;
  } catch (e) {
    return rejectWithValue(e);
  }
});

export const removeChargerFromGroups = createAsyncThunk('removeChargerFromGroup', async (data, { rejectWithValue }) => {
  try {
    const response = await axios.delete(`/charger-groups/remove_charger_from_groups/`, {
      data,
    });
    return response.data;
  } catch (e) {
    return rejectWithValue(e);
  }
});

export const deleteChargerGroup = createAsyncThunk(
  'delete/charger-group',
  async (id, { rejectWithValue, dispatch }) => {
    try {
      const response = await axios.delete(`/charger-groups/${id}/`);
      dispatch(getChargerGroups());
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const deleteManyChargerGroup = createAsyncThunk(
  'delete/charger-many-group',
  async (groups, { rejectWithValue, dispatch }) => {
    try {
      const response = await axios.delete(`/charger-groups/delete_many_groups/`, {
        params: {
          groups,
        },
      });
      dispatch(getChargerGroups());
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getGroupsByProviders = createAsyncThunk(
  'getGroupsByProviders',
  async (data, { dispatch, rejectWithValue }) => {
    try {
      const response = await axios.get('/charger-groups/', {
        params: {
          providers: data,
        },
      });
      return response.data;
    } catch (e) {
      return rejectWithValue(e);
    }
  }
);

/*---------------------------- Groups Profiles ----------------------------*/

export const addGroupProvile = createAsyncThunk('add/addGroupProvile', async (data, { dispatch, rejectWithValue }) => {
  try {
    const response = await axios.post('/charger-groups/add_profile/', data);
    return response.data;
  } catch (e) {
    return rejectWithValue(e);
  }
});

export const removeGroupProfile = createAsyncThunk(
  'remove/removeGroupProfile',
  async (id, { dispatch, rejectWithValue }) => {
    try {
      const response = await axios.delete('/charger-groups/remove_profile/', { params: { id: id } });
      return response.data;
    } catch (e) {
      return rejectWithValue(e);
    }
  }
);

export const getProfile = createAsyncThunk('get/getProfile', async (id, { dispatch, rejectWithValue }) => {
  try {
    const response = await axios.get(`/charger-groups/get_profile/`, { params: { charger_group_id: id } });
    return response.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const enableCharger = createAsyncThunk('charger/enableCharger', async (data, { dispatch, rejectWithValue }) => {
  try {
    const response = await axios.put('/charger/enable/', data);
    dispatch(getChargers({ type: 'SEELIGG' }));
    return response.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const disableCharger = createAsyncThunk(
  'charger/disableCharger',
  async (data, { dispatch, rejectWithValue }) => {
    try {
      const response = await axios.put('/charger/disable/', data);
      dispatch(getChargers({ type: 'SEELIGG' }));
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const ApproveChargers = createAsyncThunk(
  'charger/ApproveChargers',
  async (pictures_ids, { rejectWithValue }) => {
    try {
      const response = await axios.post('/charger-pictures/approve/', pictures_ids);
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const rejectChargerPictures = createAsyncThunk(
  'charger/rejectChargerPictures',
  async (id, { rejectWithValue }) => {
    try {
      const response = await axios.delete(`/charger-pictures/${id}/`, id);
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getChargerById = createAsyncThunk('charger/getChargerById', async (id, { rejectWithValue }) => {
  try {
    const response = await axios.get(`/charger/${id}/`);
    return response.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

const chargerSlice = createSlice({
  name: 'charger',
  initialState: {
    groupsByProvider: [],
    isSubmitting: false,
    chargerLogs: [],
    chargerById: null,
    adminLogs: [],
    currentChargerState: false,
    activeSession: [],
    userActiveSession: null,
    selectedCharger: null,
    chargers: [],
    chargerGroups: [],
    chargerGroup: null,
    logs: [],
    chargingSessions: [],
    qrCodeImgs: null,
    buttonEnabled: false,
    selectedRows: 0,
    routeParams: {},
    gpsLocation: {},
    map: undefined,
    layerId: null,
    layer: null,
    isSessionActive: false,
    instantKw: null,
    isEdit: false,
    chargerDialog: {
      type: 'new',
      props: {
        open: false,
      },
      data: null,
    },
    loading: false,
    openGroupDialog: false,
    addCredit: false,
    groupProfile: null,
  },
  reducers: {
    setOpenDialog(state, action) {
      state.openGroupDialog = action.payload;
    },
    setOpenAddCredit(state, action) {
      state.addCredit = action.payload;
    },
    setGroup(state, action) {
      state.chargerGroup = action.payload;
    },
    openNewChargerDialog: (state, action) => {
      state.chargerDialog = {
        type: 'new',
        props: {
          open: true,
        },
        data: null,
      };
    },
    closeNewChargerDialog: (state, action) => {
      state.chargerDialog = {
        type: 'new',
        props: {
          open: false,
        },
        data: null,
      };
    },
    openEditChargerDialog: (state, action) => {
      state.chargerDialog = {
        type: 'edit',
        props: {
          open: true,
        },
        data: action.payload,
      };
    },
    closeEditChargerDialog: (state, action) => {
      state.chargerDialog = {
        type: 'edit',
        props: {
          open: false,
        },
        data: null,
      };
    },
    getGPSLocation: (state, action) => {
      const { location, layerId } = action.payload;
      state.gpsLocation = location;
      state.layerId = layerId;
    },

    getLayer: (state, action) => {
      state.layer = action.payload;
    },

    getMapInstance: (state, action) => {
      state.map = action.payload;
    },

    enableButton: (state, action) => {
      state.buttonEnabled = action.payload;
    },

    getSelectedRows: (state, action) => {
      state.selectedRows = action.payload;
    },

    addQRCodeImg: (state, action) => {
      state.qrCodeImgs = action.payload;
    },

    updateState: (state, action) => {
      const index = state.chargers.findIndex((charger) => charger.serial_number === action.payload.serial_number);
      if (index !== -1) {
        state.chargers[index].state = action.payload.state;
        state.chargers[index].active = action.payload.active;
      }
    },

    isSessionActive: (state, action) => {
      state.isSessionActive = action.payload;
    },

    setUserActiveSessionNull: (state, action) => {
      state.userActiveSession = null;
    },
    setCharger(state, action) {
      state.selectedCharger = action.payload;
    },
    setAdminLogsCommand: (state, action) => {
      state.adminLogs.push({
        ...action.payload,
        logs: [],
      });
    },
    removeAdminLogs: (state, action) => {
      state.adminLogs = state.adminLogs.filter((item) => item.charger !== action.payload);
    },
    setAdminLogs(state, action) {
      const { charger, logs } = action.payload;
      const index = state.adminLogs.findIndex((item) => item.charger === charger);

      state.adminLogs[index] = {
        ...state.adminLogs[index],
        logs,
      };
    },
    setInstantKw(state, action) {
      state.instantKw = action.payload;
    },
    resetChargers(state) {
      state.chargers = [];
    },
    resetChargerGroup: (state, action) => {
      state.chargerGroup = null;
    },
    setIsEdit: (state, action) => {
      state.isEdit = action.payload;
    },
    getIsEdit: (state, action) => {
      return state.isEdit;
    },
  },

  extraReducers: {
    [getGroupsByProviders.pending]: (state, action) => {
      state.loading = true;
    },
    [getGroupsByProviders.fulfilled]: (state, action) => {
      state.loading = false;
      state.groupsByProvider = action.payload.data;
    },
    [getGroupsByProviders.rejected]: (state) => {
      state.loading = false;
    },
    // ------------------------------------------------------------------------
    [getChargerLogs.pending]: (state) => {
      state.loading = true;
    },
    [getChargerLogs.fulfilled]: (state, action) => {
      state.chargerLogs = action.payload.data;
      state.loading = false;
    },
    [getChargerLogs.rejected]: (state) => {
      state.loading = false;
    },
    // ------------------------------------------------------------------------
    [getLogs.fulfilled]: (state, action) => {
      state.logs = action.payload.data;
    },
    // ------------------------------------------------------------------------
    [getActiveSession.fulfilled]: (state, action) => {
      state.activeSession = action.payload.data;
    },
    // ------------------------------------------------------------------------
    [getUserActiveSession.fulfilled]: (state, action) => {
      state.userActiveSession = action.payload.data;
    },
    // ------------------------------------------------------------------------
    [createChargingSession.fulfilled]: (state, action) => {
      state.chargingSessions = action.payload.data;
    },
    // ------------------------------------------------------------------------
    [getChargers.pending]: (state) => {
      state.loading = true;
    },
    [getChargers.fulfilled]: (state, action) => {
      state.chargers = action.payload.data;
      state.loading = false;
    },
    [getChargers.rejected]: (state) => {
      state.loading = false;
    },
    // ------------------------------------------------------------------------
    [getFilteredChargers.fulfilled]: (state, action) => {
      state.chargers = action.payload.data;
    },
    // ------------------------------------------------------------------------
    [addCharger.pending]: (state) => {
      state.isSubmitting = true;
    },
    [addCharger.fulfilled]: (state, action) => {
      state.chargers.push(action.payload.data);
      state.isSubmitting = false;
    },
    [addCharger.rejected]: (state) => {
      state.loadisSubmittinging = false;
    },
    // ------------------------------------------------------------------------
    [updateCharger.pending]: (state) => {
      state.isSubmitting = true;
    },
    [updateCharger.fulfilled]: (state, action) => {
      state.isSubmitting = false;
      const index = state.chargers.findIndex((charger) => charger.id === action.payload.id);
      state.chargers[index] = {
        ...state.chargers[index],
        ...action.payload.data,
      };
    },
    [updateCharger.rejected]: (state) => {
      state.isSubmitting = false;
    },
    // ------------------------------------------------------------------------
    [deleteCharger.pending]: (state) => {
      state.isSubmitting = true;
    },
    [deleteCharger.fulfilled]: (state) => {
      state.isSubmitting = false;
    },
    [deleteCharger.rejected]: (state) => {
      state.isSubmitting = false;
    },
    // ------------------------------------------------------------------------
    [deleteManyChargers.pending]: (state) => {
      state.isSubmitting = true;
    },
    [deleteManyChargers.fulfilled]: (state) => {
      state.isSubmitting = false;
    },
    [deleteManyChargers.rejected]: (state) => {
      state.isSubmitting = false;
    },
    // ------------------------------------------------------------------------
    [getChargerGroups.pending]: (state) => {
      state.loading = true;
    },
    [getChargerGroups.fulfilled]: (state, action) => {
      state.chargerGroups = action.payload.data;
      state.loading = false;
    },
    [getChargerGroups.rejected]: (state) => {
      state.loading = false;
    },
    // ------------------------------------------------------------------------
    [addChargerGroups.pending]: (state) => {
      state.isSubmitting = true;
    },
    [addChargerGroups.fulfilled]: (state) => {
      state.isSubmitting = false;
    },
    [addChargerGroups.rejected]: (state) => {
      state.isSubmitting = false;
    },
    // ------------------------------------------------------------------------
    [deleteChargerGroup.pending]: (state) => {
      state.isSubmitting = true;
    },
    [deleteChargerGroup.fulfilled]: (state) => {
      state.isSubmitting = false;
    },
    [deleteChargerGroup.rejected]: (state) => {
      state.isSubmitting = false;
    },
    // ------------------------------------------------------------------------
    [updateChargerGroups.pending]: (state) => {
      state.isSubmitting = true;
    },
    [updateChargerGroups.fulfilled]: (state) => {
      state.isSubmitting = false;
    },
    [updateChargerGroups.rejected]: (state) => {
      state.isSubmitting = false;
    },
    // ------------------------------------------------------------------------
    [getChargerGroup.pending]: (state) => {
      state.loading = true;
    },
    [getChargerGroup.fulfilled]: (state, action) => {
      state.chargerGroup = action.payload.data;
      state.loading = false;
    },
    [getChargerGroup.rejected]: (state) => {
      state.loading = false;
    },
    // ------------------------------------------------------------------------
    [addChargerToGroups.pending]: (state) => {
      state.isSubmitting = true;
    },
    [addChargerToGroups.fulfilled]: (state) => {
      state.isSubmitting = false;
    },
    [addChargerToGroups.rejected]: (state) => {
      state.isSubmitting = false;
    },
    // ------------------------------------------------------------------------
    [addProviderToChargers.pending]: (state) => {
      state.isSubmitting = true;
    },
    [addProviderToChargers.fulfilled]: (state) => {
      state.isSubmitting = false;
    },
    [addProviderToChargers.rejected]: (state) => {
      state.isSubmitting = false;
    },
    // ------------------------------------------------------------------------
    [removeChargerFromGroups.pending]: (state) => {
      state.is = true;
    },
    [removeChargerFromGroups.fulfilled]: (state) => {
      state.loading = false;
    },
    [removeChargerFromGroups.rejected]: (state) => {
      state.loading = false;
    },
    // ------------------------------------------------------------------------
    [enableCharger.pending]: (state) => {
      state.isSubmitting = true;
    },
    [enableCharger.fulfilled]: (state) => {
      state.isSubmitting = false;
    },
    [enableCharger.rejected]: (state) => {
      state.isSubmitting = false;
    },
    // ------------------------------------------------------------------------
    [disableCharger.pending]: (state) => {
      state.isSubmitting = true;
    },
    [disableCharger.fulfilled]: (state) => {
      state.isSubmitting = false;
    },
    [disableCharger.rejected]: (state) => {
      state.isSubmitting = false;
    },
    // ------------------------------------------------------------------------
    [deleteManyChargerGroup.pending]: (state) => {
      state.isSubmitting = true;
    },
    [deleteManyChargerGroup.fulfilled]: (state) => {
      state.isSubmitting = false;
    },
    [deleteManyChargerGroup.rejected]: (state) => {
      state.isSubmitting = false;
    },
    // ------------------------------------------------------------------------
    [listChargersPicturesApproved.pending]: (state) => {
      state.loading = true;
    },
    [listChargersPicturesApproved.fulfilled]: (state) => {
      state.loading = false;
    },
    [listChargersPicturesApproved.rejected]: (state) => {
      state.loading = false;
    },
    // ------------------------------------------------------------------------
    [getChargerById.pending]: (state) => {
      state.loading = true;
    },
    [getChargerById.fulfilled]: (state, action) => {
      const { data } = action.payload;
      state.chargerById = data;
      state.loading = false;
    },
    [getChargerById.rejected]: (state) => {
      state.loading = false;
    },
    // ------------------------------------------------------------------------
    [ApproveChargers.pending]: (state) => {
      state.isSubmitting = true;
    },
    [ApproveChargers.fulfilled]: (state) => {
      state.isSubmitting = false;
    },
    [ApproveChargers.rejected]: (state) => {
      state.isSubmitting = false;
    },
    // ------------------------------------------------------------------------
    [createChargingSession.pending]: (state) => {
      state.isSubmitting = true;
    },
    [createChargingSession.fulfilled]: (state) => {
      state.isSubmitting = false;
    },
    [createChargingSession.rejected]: (state) => {
      state.isSubmitting = false;
    },
    // ------------------------------------------------------------------------
    [terminateChargingSession.pending]: (state) => {
      state.isSubmitting = true;
    },
    [terminateChargingSession.fulfilled]: (state) => {
      state.isSubmitting = false;
    },
    [terminateChargingSession.rejected]: (state) => {
      state.isSubmitting = false;
    },
    // ------------------------------------------------------------------------
    [forceTerminateChargingSession.pending]: (state) => {
      state.isSubmitting = true;
    },
    [forceTerminateChargingSession.fulfilled]: (state) => {
      state.isSubmitting = false;
    },
    [forceTerminateChargingSession.rejected]: (state) => {
      state.isSubmitting = false;
    },
    // ------------------------------------------------------------------------
    [rejectChargerPictures.pending]: (state) => {
      state.isSubmitting = true;
    },
    [rejectChargerPictures.fulfilled]: (state) => {
      state.isSubmitting = false;
    },
    [rejectChargerPictures.rejected]: (state) => {
      state.isSubmitting = false;
    },
    // ------------------------------------------------------------------------
    [addGroupProvile.pending]: (state) => {
      state.isSubmitting = true;
    },
    [addGroupProvile.fulfilled]: (state) => {
      state.isSubmitting = false;
    },
    [addGroupProvile.rejected]: (state) => {
      state.isSubmitting = false;
    },
    // ------------------------------------------------------------------------
    [removeGroupProfile.pending]: (state) => {
      state.isSubmitting = true;
    },
    [removeGroupProfile.fulfilled]: (state) => {
      state.isSubmitting = false;
    },
    [removeGroupProfile.rejected]: (state) => {
      state.isSubmitting = false;
    },
    // ------------------------------------------------------------------------
    [getProfile.pending]: (state) => {
      state.loading = true;
    },
    [getProfile.fulfilled]: (state, action) => {
      const { data } = action.payload;
      state.groupProfile = data;
      state.loading = false;
    },
    [getProfile.rejected]: (state) => {
      state.loading = false;
    },
  },
});

export const {
  openNewChargerDialog,
  closeNewChargerDialog,
  openEditChargerDialog,
  closeEditChargerDialog,
  getGPSLocation,
  getLayer,
  getSelectedRows,
  addQRCodeImg,
  getMapInstance,
  enableButton,
  updateState,
  isSessionActive,
  setUserActiveSessionNull,
  setOpenDialog,
  setOpenAddCredit,
  setGroup,
  setCharger,
  removeAdminLogs,
  setAdminLogs,
  setAdminLogsCommand,
  setInstantKw,
  resetChargers,
  resetChargerGroup,
  setIsEdit,
} = chargerSlice.actions;

export default chargerSlice.reducer;
